import Cookies from "js-cookie";

export default {
  state: {
    userInfo: {},
    menu: {
      opacity: false,
      opacityTop: 0,
      ind: "",
      subInd: "",
      title: "",
      subTitle: "",
      subOpen: true,
      list: []
    }
  },
  mutations: {
    //设置用户信息
    userInfoSet(state, res) {
      return (state.userInfo = res);
    },
    menuSet(state, res) {
      return (state.menu = {
        ...state.menu,
        ...res
      });
    }
  },
  actions: {
    //store准备
    storeReady({ dispatch }) {
      let userInfoStr = Cookies.get("zeus_userInfo");

      if (userInfoStr) {
        dispatch("userInfoSet", JSON.parse(userInfoStr));
      }
    },
    userInfoSet({ commit }, res) {
      commit("userInfoSet", res);
    }
  },
  getters: {}
};
